import ScanerModal from './ScanerModal';

export default ScanerModal;
